
import { RecommendedAction } from "../recommendedAction.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";


export class RecommendedActionSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new RecommendedAction();
        this._copyAttributes(gp, data);
        return gp;

    }

}
